import { apiRequest } from '@/services/queryClient';
import { getApiBaseUrl } from '@/config/production';

export interface MenuItem {
  id: string;
  role: string;
  label: string;
  path: string;
  icon: string | null;
  order: number;
}

const API_BASE = `${getApiBaseUrl()}/api`;

export class MenuService {
  static async getMenus(role: string): Promise<MenuItem[]> {
    const response = await apiRequest('GET', `${API_BASE}/menus?role=${role}`);
    const data = await response.json();
    return data || [];
  }
}
